import { useEffect } from 'react';
import Lenis from 'lenis';

/**
 * Smooth-scroll para la landing page (premium feel).
 * Solo se activa mientras el componente que lo usa está montado.
 */
export function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
}
